import { lazy } from "react";

export const ReviewDetailsAsync = lazy(() => import("./ReviewDetails"));
